import {TYPE_LOGEMENT} from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case TYPE_LOGEMENT.MAISON:
        return 'Maison';
      case TYPE_LOGEMENT.IMMEUBLE:
        return 'Immeuble';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/type-logement.filter.js